<div attr.name="CellOS_{{ item.id }}" class="tCol clickCol desktop" id="CellOS_{{ item.id }}">
  @if (item.event_type === 'router-offline') {
    <span class="bubble severityError" style="margin-right: 0.3125rem"></span>
  }
  @if (item.event_type === 'created' || item.event_type === 'router-online' || item.event_type === 'sdk-online' ) {
    <span
      class="bubble severityInfo"
      style="margin-right: 0.3125rem"
    ></span>
  }
  @if (item.event_type === 'deleted' || item.event_type === 'sdk-offline' || item.event_type === 'sdk-status-unknown' ) {
    <span class="bubble v7Offline" style="margin-right: 0.3125rem"></span>
  }
  @if (item.event_type) {
    <span>{{ event_type }}</span>
  }
</div>
